"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _openPlatform = require("@/api/openPlatform");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ApplicationManagement',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      queryParams: {
        configName: ''
      },
      // 编辑弹窗
      isAdd: false,
      editDialogVisible: false,
      editLoading: false,
      editForm: {
        configName: '',
        status: 1,
        remark: '',
        configId: null
      },
      editRules: {
        configName: [{
          required: true,
          message: '请输入配置名称',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }]
      },
      // 详情弹窗
      detailDialogVisible: false,
      detailData: {},
      secretVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    maskSecret: function maskSecret(secret) {
      if (!secret || secret.length < 6) return secret || '';
      return secret.slice(0, 3) + '***********' + secret.slice(-3);
    },
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              params = {};
              if (this.queryParams.configName) {
                params.configName = this.queryParams.configName;
              }
              _context.n = 2;
              return (0, _openPlatform.getAppList)(params);
            case 2:
              res = _context.v;
              if (res.code === 0) {
                this.tableData = res.data || [];
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleSearch: function handleSearch() {
      this.getList();
    },
    handleReset: function handleReset() {
      this.queryParams.configName = '';
      this.getList();
    },
    // ---------- 新增 / 编辑 ----------
    handleAdd: function handleAdd() {
      this.isAdd = true;
      this.editForm = {
        configName: '',
        status: 1,
        remark: '',
        configId: null
      };
      this.editDialogVisible = true;
    },
    handleEdit: function handleEdit(row) {
      this.isAdd = false;
      this.editForm = {
        configName: row.configName,
        status: row.status,
        remark: row.remark || '',
        configId: row.configId
      };
      this.editDialogVisible = true;
    },
    submitEditForm: function submitEditForm() {
      var _this = this;
      this.$refs.editForm.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(valid) {
          var action, payload, res, _t2;
          return (0, _regenerator2.default)().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                action = _this.isAdd ? '新增' : '编辑';
                _context2.p = 2;
                _context2.n = 3;
                return _this.$confirm("\u786E\u8BA4".concat(action, "\u8BE5\u914D\u7F6E\u5417\uFF1F"), '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                });
              case 3:
                _this.editLoading = true;
                payload = {
                  configName: _this.editForm.configName,
                  status: _this.editForm.status,
                  remark: _this.editForm.remark
                };
                if (!_this.isAdd && _this.editForm.configId) {
                  payload.configId = _this.editForm.configId;
                }
                _context2.n = 4;
                return (0, _openPlatform.saveOrUpdateApp)(payload);
              case 4:
                res = _context2.v;
                if (res.code === 0) {
                  _this.$message({
                    type: 'success',
                    message: _this.isAdd ? '新增成功！' : '编辑成功！'
                  });
                  _this.editDialogVisible = false;
                  _this.getList();
                }
                _context2.n = 6;
                break;
              case 5:
                _context2.p = 5;
                _t2 = _context2.v;
                if (_t2 !== 'cancel') {
                  console.error(_t2);
                }
              case 6:
                _context2.p = 6;
                _this.editLoading = false;
                return _context2.f(6);
              case 7:
                return _context2.a(2);
            }
          }, _callee2, null, [[2, 5, 6, 7]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    resetEditForm: function resetEditForm() {
      this.$refs.editForm && this.$refs.editForm.resetFields();
      this.editDialogVisible = false;
    },
    // ---------- 删除 ----------
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u914D\u7F6E\u300C".concat(row.configName, "\u300D\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _openPlatform.deleteApp)({
                configId: row.configId
              });
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                _this2.$message({
                  type: 'success',
                  message: '删除成功！'
                });
                _this2.getList();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.error(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))).catch(function () {});
    },
    // ---------- 状态切换 ----------
    handleStatusChange: function () {
      var _handleStatusChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(row, val) {
        var res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _openPlatform.saveOrUpdateApp)({
                configId: row.configId,
                configName: row.configName,
                status: val ? 1 : 0,
                remark: row.remark || ''
              });
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '状态更新成功'
                });
                this.getList();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.error(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function handleStatusChange(_x2, _x3) {
        return _handleStatusChange.apply(this, arguments);
      }
      return handleStatusChange;
    }(),
    // ---------- 详情 ----------
    handleDetail: function handleDetail(row) {
      this.detailData = row;
      this.detailDialogVisible = true;
    },
    // ---------- 重置 AppSecret ----------
    handleResetSecret: function handleResetSecret() {
      var _this3 = this;
      this.$confirm('重置后旧AppSecret立即失效，第三方平台需重新对接，否则报错。确认重置？', '提示', {
        confirmButtonText: '确认重置',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _openPlatform.resetAppSecret)({
                configId: _this3.detailData.configId
              });
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                _this3.$message({
                  type: 'success',
                  message: '重置成功！'
                });
                _this3.detailDialogVisible = false;
                _this3.getList();
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.error(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 2]]);
      }))).catch(function () {});
    },
    // ---------- 复制 ----------
    copyText: function () {
      var _copyText = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(text) {
        var _this4 = this;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (text) {
                _context6.n = 1;
                break;
              }
              this.$message({
                type: 'warning',
                message: '无可复制内容'
              });
              return _context6.a(2);
            case 1:
              try {
                this.$copyText(text).then(function () {
                  _this4.$notify.success({
                    title: '温馨提示',
                    message: '拷贝成功'
                  });
                }).catch(function () {
                  _this4.$notify.success({
                    title: '温馨提示',
                    message: '拷贝失败，请手动复制'
                  });
                });
              } catch (err) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '拷贝失败，请手动复制'
                });
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function copyText(_x4) {
        return _copyText.apply(this, arguments);
      }
      return copyText;
    }()
  }
};